module.exports = {
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:3000",
  appUrl: process.env.REACT_APP_APP_URL || "http://localhost:3001",
  gbifApiUrl: process.env.GBIF_API_URL || "https://api.gbif.org/v1/",
  fetchIntervals: {
    messages: 5000,
  },
  apiRoutes: {
    ssoLogin: "/v1/account/sso-login",
    getAccounts: "/v1/account",
    getAccount: "/v1/account",
    createAccount: "/v1/account",
    updateAccount: "/v1/account",
    deleteAccount: "/v1/account",
    getAccountPermissions: "/v1/account/get-permissions",
    resetPassword: "/v1/account/reset-password",
    sendPassword: "/v1/account/send-password",
    linkAccountAndCustomer: "/v1/customers/link-account",
    unlinkAccountAndCustomer: "/v1/customers/unlink-account",
    getPlant: "/v1/plant",
    getPlants: "/v1/plant",
    createPlant: "/v1/plant",
    updatePlant: "/v1/plant",
    deletePlant: "/v1/plant",
    duplicatePlant: "/v1/plant/duplicate",
    getPlantSection: "/v1/plant-section",
    getPlantSections: "/v1/plant-section/list-by-type",
    createPlantSection: "/v1/plant-section",
    updatePlantSection: "/v1/plant-section",
    deletePlantSection: "/v1/plant-section",

    getContent: "/v1/content",
    getContents: "/v1/content",
    getContentsByType: "/v1/content/list-by-type",
    getContentTypes: "/v1/content/types",
    createContent: "/v1/content",
    updateContent: "/v1/content",
    deleteContent: "/v1/content",
    toggleContentCustomer: "/v1/content/toggle-customer",
    uploadImages: "/v1/media/upload-file",

    uploadCSV: "/v1/account/upload",

    deleteSectionImage: "/v1/plant-section/image",
    updateSectionImageInfo: "/v1/plant-section/image",

    deleteContentImage: "/v1/content/image",
    updateContentImageInfo: "/v1/content/image",

    getCustomer: "/v1/customers",
    getCustomers: "/v1/customers",
    createCustomer: "/v1/customers",
    updateCustomer: "/v1/customers",
    deleteCustomer: "/v1/customers",
    getPlantCustomers: "/v1/customers/list-by-plant",
    linkPlantToCustomer: "/v1/customers/link-plant",
    unlinkPlantFromCustomer: "/v1/customers/unlink-plant",
    toggleTutorialVideoCustomer: "/v1/tutorial-videos/link-unlink-customer",
    getCustomerPlantSectionTypeOrder: "/v1/customers/plant-section-type-order",
    updateCustomerPlantSectionTypeOrder:
      "/v1/customers/plant-section-type-order",
    getRegion: "/v1/region",
    getRegions: "/v1/region",
    createRegion: "/v1/region",
    updateRegion: "/v1/region",
    deleteRegion: "/v1/region",
    getPlantRegions: "/v1/region/by-plant",
    unlinkRegionAndPlant: "/v1/region/unlink-plant",
    linkRegionAndPlant: "/v1/region/link-plant",

    // quiz
    getQuiz: "/v1/quiz",
    getLeaderboard: "/v1/quiz/leaderboard",
    addOrUpdateQuiz: "/v1/quiz/upsert",
    resetQuiz: "/v1/quiz/reset",
    getQuizList: "/v1/quiz/list-by-customer",

    getQuizQuestion: "/v1/quiz-question",
    getQuizQuestions: "/v1/quiz-question",
    createQuizQuestion: "/v1/quiz-question",
    updateQuizQuestion: "/v1/quiz-question",
    deleteQuizQuestion: "/v1/quiz-question",
    duplicateQuizQuestion: "/v1/quiz-question/duplicate",
    deleteQuizQuestionImage: "/v1/quiz-question/image",
    updateQuizQuestionImageInfo: "/v1/quiz-question/image",
    linkQuizQuestionAndCustomer: "/v1/quiz-question/link-customer",
    unlinkQuizQuestionAndCustomer: "/v1/quiz-question/unlink-customer",
    toggleGame: "/v1/account/toggle-game",

    // quiz contents
    getQuizContent: "/v1/quiz-content",
    getQuizContents: "/v1/quiz-content",
    createQuizContent: "/v1/quiz-content",
    updateQuizContent: "/v1/quiz-content",
    deleteQuizContent: "/v1/quiz-content",

    deleteQuizContentImage: "/v1/quiz-content/image",
    updateQuizContentImageInfo: "/v1/quiz-content/image",

    linkUnlinkQuizContentCustomer: "/v1/quiz-content/link-unlink-customer",

    // answer
    getQuizAnswer: "/v1/quiz-answer",
    getQuizAnswers: "/v1/quiz-answer",
    getQuizQuestionAnswers: "/v1/quiz-answer",
    createQuizAnswer: "/v1/quiz-answer",
    updateQuizAnswer: "/v1/quiz-answer",
    deleteQuizAnswer: "/v1/quiz-answer",
    deleteQuizAnswerImage: "/v1/quiz-answer/image",
    updateQuizAnswerImageInfo: "/v1/quiz-answer/image",

    // question feedback
    getQuizQuestionFeedback: "/v1/quiz-question-feedback",
    createQuizQuestionFeedback: "/v1/quiz-question-feedback",
    updateQuizQuestionFeedback: "/v1/quiz-question-feedback",
    deleteQuizQuestionFeedback: "/v1/quiz-question-feedback",
    deleteQuizQuestionFeedbackImage: "/v1/quiz-question-feedback/delete-image",
    updateQuizQuestionFeedbackImageInfo:
      "/v1/quiz-question-feedback/update-image-info",

    // messages
    getConversations: "/v1/message/conversations",
    createMessage: "/v1/message",
    forwardMessage: "/v1/message/forward",

    readMessageThread: "/v1/message/read",

    notify: "/v1/message/notify",

    // activity logs
    getActivityLog: "/v1/user-activity-log",

    // permissions
    getPermissions: "/v1/permission/list",
    togglePermission: "/v1/permission/toggle",

    deleteMessage: "/v1/message",
    getNotificationImage: "/v1/plant-identify/list-notify-images",
    saveNotificationDecision: "/v1/plant-identify/notify-image",
    deleteNotificationImage: "/v1/plant-identify/notify-image",

    uploadRestrictedRegion: "/v1/geo-spatial-tracking",
    getRestrictedRegion: "/v1/geo-spatial-tracking",
    getRestrictedRegions: "/v1/geo-spatial-tracking",
    deleteRestrictedRegion: "/v1/geo-spatial-tracking",
    updateRestrictedRegion: "/v1/geo-spatial-tracking",

    // PlantDex
    getPlantdexSubmissions: "/v1/plantdex/submissions",

    // Tags
    getTags: "/v1/tag",
    getTag: "/v1/tag",
    createTag: "/v1/tag",
    updateTag: "/v1/tag",
    deleteTag: "/v1/tag",
    assignTagToAccount: "/v1/tag/assign",
    getTagsByAccount: "/v1/tag/by-account",
    getTagsForAccountAndCustomer: "/v1/tag/for-account-and-customer",
    batchUpdateAccountTags: "/v1/tag/batch-update",

    // Tutorial Videos
    getTutorialVideos: "/v1/tutorial-videos",
    getTutorialVideo: "/v1/tutorial-videos",
    getTutorialVideoCustomers: "/v1/tutorial-videos",
    createTutorialVideo: "/v1/tutorial-videos",
    updateTutorialVideo: "/v1/tutorial-videos",
    deleteTutorialVideo: "/v1/tutorial-videos",
    linkUnlinkTutorialVideoCustomer: "/v1/tutorial-videos/link-unlink-customer",
    setTutorialVideoCustomers: "/v1/tutorial-videos",
    duplicateTutorialVideo: "/v1/tutorial-videos/duplicate",

    // Environmental Tailgates
    getEnvironmentalTailgates: "/v1/environmental-tailgates",
    getEnvironmentalTailgate: "/v1/environmental-tailgates",
    getEnvironmentalTailgateCustomers: "/v1/environmental-tailgates",
    createEnvironmentalTailgate: "/v1/environmental-tailgates",
    updateEnvironmentalTailgate: "/v1/environmental-tailgates",
    deleteEnvironmentalTailgate: "/v1/environmental-tailgates",
    toggleEnvironmentalTailgateCustomer:
      "/v1/environmental-tailgates/link-unlink-customer",
    duplicateEnvironmentalTailgate: "/v1/environmental-tailgates/duplicate",

    // Surveys
    getSurveys: "/v1/surveys",
    getSurvey: "/v1/surveys",
    createSurvey: "/v1/surveys",
    duplicateSurvey: "/v1/surveys/duplicate",
    updateSurvey: "/v1/surveys",
    deleteSurvey: "/v1/surveys",
    getSurveyCustomers: "/v1/surveys",
    toggleSurveyCustomer: "/v1/surveys/link-unlink-customer",
    getSurveysReport: "/v1/surveys/report",
    getEnvironmentalTailgatesReport: "/v1/environmental-tailgates/report",
    getTutorialVideosReport: "/v1/tutorial-videos/report",

    // VMU courses
    getVmuCourses: "/v1/vmu",
    getVmuCourse: "/v1/vmu",
    createVmuCourse: "/v1/vmu",
    updateVmuCourse: "/v1/vmu",
    deleteVmuCourse: "/v1/vmu",
    getVmuCourseAccounts: "/v1/vmu",
    toggleVmuCourseAccount: "/v1/vmu/link-unlink-account",

    // VMU customers / settings
    getVmuCustomers: "/v1/vmu-settings/customers",
    getVmuCustomer: "/v1/vmu-settings",
    updateVmuSettings: "/v1/vmu-settings",

    // VMU resources
    getVmuResources: "/v1/vmu-resources",
    createVmuResource: "/v1/vmu-resources",
    updateVmuResource: "/v1/vmu-resources",
    deleteVmuResource: "/v1/vmu-resources",
  },
  reactQuillModules: {
    toolbar: [
      [{ header: "1" }, { header: "3" }, { header: [3, 4, 5, 6] }],
      [{ size: [] }],
      ["bold", "italic", "undeline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
      [
        {
          color: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#0047b2",
            "#6b24b2",
            "#444444",
            "#5c0000",
            "#663d00",
            "#666600",
            "#003700",
            "#002966",
            "#3d1466",
            "custom-color",
          ],
        },
      ],
    ],
  },
  reactQuillModulesHyperLink: {
    toolbar: [["link"], ["clean"]],
  },
  reactQuillFormats: [
    "header",
    "size",
    "bold",
    "italic",
    "undeline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
  ],
  accountRoleIdsByName: {
    admin: 1,
    member: 2,
    manager: 3,
  },
  accountRolesById: {
    1: "Admin",
    2: "Member",
    3: "Manager",
  },
};
